export default __webpack_public_path__ + "static/media/bouton_dataflow.6224d35a.svg";